import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent"
export function drawShopTable(doc, shop, rows, total) {
 let startY = doc.lastAutoTable
  ? doc.lastAutoTable.finalY + 20
  : 28;

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}


  const columnStyles = {
  0: { cellWidth: 35, halign: "left" },
  1: { cellWidth: 26 },
  2: { cellWidth: 26 },
  3: { cellWidth: 26 },
  4: { cellWidth: 26 },
  5: { cellWidth: 26 },
  6: { cellWidth: 26 },
  7: { cellWidth: 26 },
  8: { cellWidth: 26 },
  9: { cellWidth: 26 },
};


const pageHeight = doc.internal.pageSize.getHeight();

if (startY > pageHeight - 25) {
  doc.addPage();
  startY = 28;
}

doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_GROUP); 
doc.rect(14, startY - 10, 269, 8, "F");
doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_GROUP); 
doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_GROUP);
doc.text(`Shop Number - ${shop}`,20, startY - 5);
  autoTable(doc, {
    startY,
...PDF_TABLE_STYLE,
    head: [[
      "Work Order",
      "Prime Labour",
      "Prime Store",
      "",
      "On Cost Labour",
      "On Cost Store",
      "SUP Store",
      "Freight",
      "Store",
      "Profit"
    ]],

    body: rows.map(r => [
      r.WORKORDER,
      format(r.PRIMECOST_LABOUR),
      format(r.PRIMECOST_STORES),
      r.PRIMECOST_MISC,
      format(r.ONCOST_LABOUR),
      format(r.ONCOST_STORES),
      format(r.ONCOST_SUP_STORES || "0.00"),
      format(r.ONCOST_FREIGHT || "0.00"),
      format(r.PROFORMA_STORES || "0.00"),
      format(r.PROFIT || "0.00"),
    ]),

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right"
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      fontSize: PDFCOLORSHEME.FONT_SIZE_HEADER,
      halign: "center",
      fontStyle: "bold"
    },

    columnStyles,

    
  });

  const y = doc.lastAutoTable.finalY;

autoTable(doc, {
  startY: y,
  body: [[
    `SHOP TOTAL - ${String(shop).trim()}`,
    format(total.primeLabour.toFixed(2)),
    format(total.primeStores.toFixed(2)),
    total.primeMisc,
    format(total.onCostLabour.toFixed(2)),
    format(total.onCostStores.toFixed(2)),
    format(total.supStore || "0.00"),
    format(total.freight || "0.00"),
    format(total.store || "0.00"),
    format(total.profit || "0.00"),
  ]],
  
  theme: "plain",
  styles: {
    fillColor: PDFCOLORSHEME.BACK_COLOR_TOTAL,
     textColor: PDFCOLORSHEME.FONT_COLOR_TOTAL,
     fontSize: PDFCOLORSHEME.FONT_SIZE_TOTAL,
    fontStyle: "bold",
    halign: "right"
  },
  columnStyles,

 
});

}